import {
  GetMaterializeItemTasksDocument,
  GetStepMaterializationDatesDocument,
  MaterializedProcessDocument,
  TasksValueObjectsTaskIdentifierEnum,
  TasksValueObjectsTaskStatusEnum,
} from 'generated/resources/graphql'

import { useBulkUpdateTasks } from 'modules/tasks/hooks/useBulkUpdateTasks'

type RefectVariablesTypes = {
  materializedProcessId: string
  taskId: string
  identifier?: TasksValueObjectsTaskIdentifierEnum
}

interface IVariable {
  id: string
  done: boolean
  identifier?: TasksValueObjectsTaskIdentifierEnum
}

type ResolveTaskProps = {
  variables: IVariable
  refecthVars: RefectVariablesTypes
}

export const useResolveMaterializedTask = () => {
  const { bulkUpdateTasks, loading } = useBulkUpdateTasks()

  return {
    resolveTask: ({ variables, refecthVars }: ResolveTaskProps) => {
      const status: TasksValueObjectsTaskStatusEnum = variables.done ? 'done' : 'todo'

      const tasks = [
        {
          status,
          id: variables.id,
          identifier: variables.identifier,
        },
      ]

      return bulkUpdateTasks({
        variables: { tasks },
        refetchQueries: [
          {
            query: MaterializedProcessDocument,
            variables: {
              id: refecthVars.materializedProcessId,
            },
          },
          {
            query: GetStepMaterializationDatesDocument,
            variables: {
              materializedProcessId: refecthVars.materializedProcessId,
            },
          },
          {
            query: GetMaterializeItemTasksDocument,
            variables: {
              ids: [refecthVars.taskId],
              identifier: refecthVars.identifier,
            },
          },
        ],
        awaitRefetchQueries: true,
      })
    },
    loading,
  }
}
